import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent {
  constructor(private popoverCtrl: PopoverController) {}

  close(role = 'close') {
    this.popoverCtrl.dismiss(null, role);
  }
}
